import { normalizeEvidenceText } from 'utils/gradingEvidence';

export const findEvidenceTarget = (root, target, { selector = 'mark', idAttribute = 'evidenceId' } = {}) => {
    if (!root) return null;

    const elements = [...root.querySelectorAll(selector)];
    const evidenceId = target?.evidenceId == null ? null : String(target.evidenceId);
    const targetById = evidenceId ? elements.find((element) => element.dataset?.[idAttribute] === evidenceId) : null;
    if (targetById) return targetById;

    const quote = normalizeEvidenceText(target?.quote);
    return quote
        ? elements.find((element) => normalizeEvidenceText(element.textContent).includes(quote)) || null
        : null;
};
